'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.getByPath = exports.getByPathMutable = void 0;
const getByPathMutable = (obj, path) => {
  // If not yet an array, get the keys from the string-path
  if (!Array.isArray(path)) path = path.toString().match(/[^.[\]]+/g) || [];
  return path.slice(0, -1).reduce(
    (
      a,
      c,
      i // Iterate all of them except the last one
    ) =>
      Object(a[c]) === a[c] // Does the key exist and is its value an object?
        ? // Yes: then follow that path
        a[c]
        : // No: create the key. Is the next key a potential array-index?
        (a[c] =
          Math.abs(parseInt(path[i + 1], 10)) >> 0 === +path[i + 1]
            ? [] // Yes: assign a new array object
            : {}), // No: assign a new plain object
    obj
  )[path[path.length - 1]];
};
exports.getByPathMutable = getByPathMutable;
const getByPath = (obj = {}, path = '') => {
  // If not yet an array, get the keys from the string-path
  if (!Array.isArray(path)) path = path.toString().match(/[^.[\]]+/g) || [];
  // Iterate all of them except the last one
  return path.slice(0, -1).reduce((container, key, i) => {
    // Does the key exist and is its value an object?
    // Yes: then follow that path
    if (Object(container[key]) === container[key]) return container[key];
    // No: Is the next key a potential array-index?
    return Math.abs(parseInt(path[i + 1], 10)) >> 0 === +path[i + 1]
      ? [] // Yes: assign a new array object
      : {}; // No: assign a new plain object
  }, obj)[path[path.length - 1]];
};
exports.getByPath = getByPath;
exports.default = getByPath;
